import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LocaldataService } from '../../service/localdata/localdata.service';
import { AuthService } from "../../service/auth/auth.service";
import { ConfigService } from '../../service/config/config.service';



@Component({
  selector: 'app-mainnavigation',
  templateUrl: './mainnavigation.component.html',
  styleUrls: ['./mainnavigation.component.scss'],
})
export class MainnavigationComponent implements OnInit {
  //public mainnav:boolean = false;
  @Input() mainnav: boolean;
  @Input() showNotifications: boolean;
  @Input() isInverted: boolean;
  @Output() mainnavChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private router: Router, private config:ConfigService, private localData: LocaldataService, private auth: AuthService) { }

  ngOnInit() {
    //this.mainnav = false;
  }

  ngAfterViewInit(){
  }


  changeToggle(){
    this.mainnav = !this.mainnav;
    this.mainnavChange.emit(this.mainnav);
  }


  logout(){
    this.auth.logout();
    this.mainnav = false;
  }

  navigateTo(path: string):void{
    this.router.navigateByUrl(path);
    this.mainnav = false;
    this.mainnavChange.emit(false);
  }

}